import { Tooltip } from 'antd';
import React, { type FC } from 'react';

interface TruncateTextProps {
  text: string | undefined;
  truncateEnd?: boolean;
  maxLength?: number;
  separator?: string;
  hasTooltip?: boolean;
  width?: number;
  style?: React.CSSProperties;
}

export const TruncateText: FC<TruncateTextProps> = ({
  text,
  truncateEnd = false,
  maxLength = 30,
  separator = '...',
  hasTooltip = true,
  width,
  style,
}) => {
  if (!text) return null;
  if (text.length <= maxLength + separator.length)
    return <div style={{ wordBreak: 'break-word', width, ...style }}>{text}</div>;

  const frontChars = Math.ceil(maxLength / 2);
  const backChars = Math.floor(maxLength / 2);

  const Wrapper = hasTooltip ? Tooltip : React.Fragment;

  return (
    <div style={{ wordBreak: 'break-word', width, ...style }}>
      <Wrapper {...(hasTooltip ? { title: text } : {})}>
        {truncateEnd
          ? `${text.substring(0, maxLength)}${separator}`
          : `${text.substring(0, frontChars)}${separator}${text.substring(text.length - backChars)}`}
      </Wrapper>
    </div>
  );
};
